<section class="shiksha-pipeline-risk" [attr.aria-label]="content.ariaLabel">
    <app-shiksha-dashboard-subtitle-header
        [title]="content.title"
        [subtitle]="content.subtitle"
        [iconName]="uiConfig.titleIconName"
        [iconVariant]="'alert'"
        [iconSize]="uiConfig.titleIconSize"
    />

    <div class="shiksha-pipeline-risk__stages shiksha-pipeline-risk__stages--minimal">
        @for (stage of renderedStages(); track stage.stageKey) {
            <article
                class="shiksha-pipeline-risk__simple-card"
                [attr.aria-label]="stageRiskAriaLabel(stage)"
            >
                <h3 class="shiksha-pipeline-risk__simple-title">
                    {{ stageSummaryTitle(stage) }}
                </h3>

                <p class="shiksha-pipeline-risk__simple-foot">
                    <span class="shiksha-pipeline-risk__simple-foot-label">{{
                        content.highRiskLabel
                    }}</span>
                    <span class="shiksha-pipeline-risk__simple-foot-dot" aria-hidden="true"></span>
                    <span class="shiksha-pipeline-risk__simple-foot-group">
                        <strong class="shiksha-pipeline-risk__simple-foot-value">{{
                            totalStageLeads(stage)
                        }}</strong>
                        <span class="shiksha-pipeline-risk__simple-foot-muted">{{
                            dealLabel(totalStageLeads(stage))
                        }}</span>
                    </span>
                    @if (showAtRiskAmount(stage)) {
                        <span
                            class="shiksha-pipeline-risk__simple-foot-dot"
                            aria-hidden="true"
                        ></span>
                        <span
                            class="shiksha-pipeline-risk__simple-foot-group shiksha-pipeline-risk__simple-foot-group--amount"
                        >
                            <strong class="shiksha-pipeline-risk__simple-foot-value">
                                <span class="shiksha-pipeline-risk__simple-foot-rupee">{{
                                    rupeeSymbol
                                }}</span
                                >{{ highRiskAmountFigures(stage) }}
                            </strong>
                            <span class="shiksha-pipeline-risk__simple-foot-muted">{{
                                content.atRiskSuffix
                            }}</span>
                        </span>
                    }
                </p>
            </article>
        }
    </div>
</section>
